import Joi from 'joi';
import PropTypes from 'prop-types';

import Form from '../../common/form';

import { getFileUploadTypes } from '../../../utils/utilities';
import { IMAGE_LIMITS } from '../../../utils/constants';

class Drawing extends Form {
	state = {
		data: { drawing: [] },
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		drawing: Joi.array().min(1).max(IMAGE_LIMITS.ANOMALY_LOCATIONS).required().label('Drawing'),
	};

	static propTypes = {
		initialDrawing: PropTypes.array,
		onAdd: PropTypes.func,
	};

	componentDidMount() {
		if (this.props.initialDrawing) {
			this.setState({ data: { drawing: this.props.initialDrawing }});
		}
	}

	doSubmit = (): void => {
		this.props.onAdd(this.state.data.drawing);
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<p className="form-title"></p>

				{this.renderFileInput({
					max: IMAGE_LIMITS.ISO_IMAGE,
					multiple: IMAGE_LIMITS.ISO_IMAGE > 1,
					name: 'drawing',
					accept: 'image/*,application/pdf',
					label: 'Drawing',
					sublabel: 'Upload Drawing',
					types: getFileUploadTypes(),
				})}

				<div className="d-flex justify-content-end">
					{this.renderButton('Save Images')}
				</div>
			</form>
		);
	}
}

export default Drawing;
